/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FormDocument } from './FormDocument';
import {
    FormDocumentFromJSON,
    FormDocumentFromJSONTyped,
    FormDocumentToJSON,
    FormDocumentToJSONTyped,
} from './FormDocument';

/**
 * 
 * @export
 * @interface ListFormDocumentsResponse
 */
export interface ListFormDocumentsResponse {
    /**
     * 
     * @type {Array<FormDocument>}
     * @memberof ListFormDocumentsResponse
     */
    documents: Array<FormDocument>;
}

/**
 * Check if a given object implements the ListFormDocumentsResponse interface.
 */
export function instanceOfListFormDocumentsResponse(value: object): value is ListFormDocumentsResponse {
    if (!('documents' in value) || value['documents'] === undefined) return false;
    return true;
}

export function ListFormDocumentsResponseFromJSON(json: any): ListFormDocumentsResponse {
    return ListFormDocumentsResponseFromJSONTyped(json, false);
}

export function ListFormDocumentsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListFormDocumentsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'documents': ((json['documents'] as Array<any>).map(FormDocumentFromJSON)),
    };
}

export function ListFormDocumentsResponseToJSON(json: any): ListFormDocumentsResponse {
    return ListFormDocumentsResponseToJSONTyped(json, false);
}

export function ListFormDocumentsResponseToJSONTyped(value?: ListFormDocumentsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documents': ((value['documents'] as Array<any>).map(FormDocumentToJSON)),
    };
}

